import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectModalDonations } from '../../features/p2p.selectors';
import { PeerToPeerManageService } from '../../services/peer-to-peer-manage/peer-to-peer-manage.service';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone:true,
  selector: 'app-p2p-details-donations-info',
  templateUrl: './p2p-details-donations-info.component.html',
  styleUrls: ['./p2p-details-donations-info.component.scss'],
  imports: [CommonModule]
})
export class P2pDetailsDonationsInfoComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Output() selectedDonor = new EventEmitter<any>();

  public P2PDonations$: any = this.store.pipe(
    select(selectModalDonations),
  );

  public p2pDonations = [];

  constructor(
    public store: Store,
    public peerToPeerManageService: PeerToPeerManageService,
  ) { }

  ngOnInit() {
    this.P2PDonations$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((donations)=> {
      this.p2pDonations = donations;
    })
  }

  donorSelected(donation) {
    this.selectedDonor.emit(donation);
  }
    
  getAmountDisplay(amount) {
    return this.peerToPeerManageService.addCommasToNumber(amount)
  }

  getDate(timestamp) {
    const currentTime = Math.floor(Date.now() / 1000);
    const seconds = currentTime - timestamp;
  
    if (seconds < 60) {
      return seconds + "s ago";
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return minutes + "m ago";
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return hours + "h " + minutes + "m ago";
    } else {
      const days = Math.floor(seconds / 86400);
      return days + "d ago";
    }
  }
}
